<app-header-content>
  <h1 class="text-center white">PAGE NOT FOUND<span class="large">404</span></h1>
</app-header-content>
